import type { WeakestLinkQuiz } from "@quizshow/protocol";

export const weakestLinkModuleManifest = {
  id: "weakest-link",
  version: 1,
  name: "Der Dümmste fliegt raus",
  capabilities: ["scoring", "lives", "elimination", "buzzer", "question_timer", "submissions", "jokers"],
} as const;

export function createStarterWeakestLinkQuiz(): WeakestLinkQuiz {
  return {
    formatVersion: 1,
    quizId: crypto.randomUUID(),
    moduleId: "weakest-link",
    moduleVersion: 1,
    title: "Der Dümmste fliegt raus",
    description: "Fragen, Leben und Ausscheiden in mehreren Runden.",
    updatedAt: new Date().toISOString(),
    mediaAssets: [],
    allowSelfTeamSelection: false,
    allowParticipantJokers: false,
    autoOpenBuzzer: false,
    startingLives: 3,
    questionOrder: "fixed",
    scoringMode: "points",
    ranks: [],
    jokers: [
      {
        jokerId: crypto.randomUUID(),
        name: "50:50",
        description: "Entfernt die konfigurierte Anzahl falscher Antworten.",
        color: "#ef4565",
        icon: "50",
        type: "fifty-fifty",
        startingCount: 1,
      },
      {
        jokerId: crypto.randomUUID(),
        name: "Frage weitergeben",
        description: "Gibt die aktuelle Frage nach Bestätigung durch den Host an einen anderen aktiven Spieler weiter.",
        color: "#f5b942",
        icon: "→",
        type: "pass-question",
        startingCount: 1,
      },
    ],
    usesLives: true,
    defaultLives: 3,
    theme: {
      primaryColor: "#8f1838",
      accentColor: "#ef4565",
      backgroundColor: "#100b11",
    },
    questions: [
      {
        questionId: crypto.randomUUID(),
        prompt: "Wer bleibt im Spiel?",
        answers: [
          { optionId: crypto.randomUUID(), text: "Richtige Antwort", isCorrect: true },
          { optionId: crypto.randomUUID(), text: "Falsche Antwort", isCorrect: false },
          { optionId: crypto.randomUUID(), text: "Noch eine falsche Antwort", isCorrect: false },
        ],
        timerEnabled: true,
        timerSeconds: 300,
        points: 100,
        fiftyFiftyRemoveCount: 1,
        questionType: "normal",
        answerMode: "multiple-choice",
        selectionMode: "single",
        evaluationMode: "manual",
        media: {},
      },
    ],
  };
}
